import React, { useState, useEffect } from "react";
import "../style/dashboard.css";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Widget from "../components/Widget";
import CircularProgress from '@mui/material/CircularProgress';

export default function Dashboard() {
  // State for managing loading
  const [loading, setLoading] = useState(true);

  // Simulate data fetching with a delay
  useEffect(() => {
    // Simulate a delay for data fetching (e.g., 2 seconds)
    const fetchData = () => {
      setTimeout(() => {
        setLoading(false);
      }, 2000); // 2 seconds delay
    };

    fetchData();
  }, []);

  return (
    <>
      <div className="home">
        <Sidebar />
        <div className="home-container">
          <Header />
          
          {/* Widget section with loader */}
          <div className="widgets">
            {loading ? (
              <div className="widget-loader">
                <CircularProgress
                size={30}
                style={{ color: "#7451f8" }}
                />
                <h3>Loading...</h3>
              </div>
            ) : (
              <Widget />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
